{
    "MainmenuPinmenu": "Fixar menu",
    "MainmenuPinnedmenu": "Desafixar menu",
    "MainmenuHome": "Casa",
    "MainmenuMoreoptions": "Mais opções",
    "MainmenuWhatisnew": "O que há de novo?",
    "MainmenuOmnichannelPanel": "Painel Omnicanal",
    "MainmenuPrivacynotice": "Notificação de privacidade",
    "MainMenuCookiePolicy": "Política de cookies",
    "MainmenuTermsofservice": "Termos e condições de serviço",
    "MainmenuSetlanguage": "Definir idioma",
    "MainmenuHelp": "Ajuda",
    "MainmenuChangePassword": "alterar palavra-passe",
    "MainmenuServerInfo": "Informações do servidor",
    "MainmenuSendfeedback": "Envie-nos o seu feedback!",
    "MainmenuButtonTitleAddreport": "Adicionar novo relatório",
    "MainmenuButtonTitleDeletereport": "remover relatório",
    "MainmenuButtonTitlePermanentlyDeletereport": "remover relatório permanentemente",
    "MainmenuButtonSubTitleDisabled": "(Selecione alguns relatórios para usar esta opção)",
    "NAME": "LanguageMainMenu",
    "MainMenu_RestartTour": "Reiniciar a digressão",
    "MAIN_MENU_SETTINGS_CLEAR_CONTENTFUL_CACHE": "Limpar cache de conteúdo",
    "MainMenu_Turn_On_Insights_Hub": "Ativar o painel de controlo do Insights",
    "MainMenu_Turn_Off_Insights_Hub": "Desativar o painel de controlo do Insights",
    "MainMenu_Timezone": "Alterar fuso horário"
}